import { TranslationSegment } from '@/models/TranslationSegment';
import { TranslationState } from '@/models/TranslationState';

import { segmentTextLogicService } from './segmentTextLogicService';
import { calculateSegmentStatus } from './segmentStatusCalculator';

export class segmentStateService {
    private static instance: segmentStateService;
    private segmentTextLogicService: segmentTextLogicService;

    private constructor() {
        this.segmentTextLogicService = segmentTextLogicService.getInstance();
    }

    public static getInstance(): segmentStateService {
        if (!segmentStateService.instance) {
            segmentStateService.instance = new segmentStateService();
        }
        return segmentStateService.instance;
    }

    clearSelectedTranslation(translationSegment: TranslationSegment): void {
        if (translationSegment.segmentTranslation != null) {
            if (translationSegment.segmentTranslation.targetSegment != translationSegment.draftData.text) {
                translationSegment.segmentTranslation = null;
            }
        }
    }

    setNewState(translationSegment: TranslationSegment): void {
        this.recalculateSegmentStatus(translationSegment);

        if (this.segmentTextLogicService.draftIsEmpty(translationSegment)) {
            this.clearSelectedTranslation(translationSegment);
            this.setStateNotTranslated(translationSegment);
        } else if (this.segmentTextLogicService.translationNotSelected(translationSegment) || this.segmentTextLogicService.draftNotEqalTranslation(translationSegment)) {
            this.setStateDraft(translationSegment);
        } else if (this.segmentTextLogicService.matchPercentIs100(translationSegment)) {
            this.setStateTranslated(translationSegment);
        } else {
            this.setStatePreTranslated(translationSegment);
        }
    }

    recalculateSegmentStatus(translationSegment: TranslationSegment): void {
        translationSegment.segmentStatus = calculateSegmentStatus(translationSegment.sourceData.text, translationSegment.draftData.text);
    }

    setStateNotTranslated(translationSegment: TranslationSegment): void {
        translationSegment.translationState = TranslationState.NotTranslated;
    }

    setStateDraft(translationSegment: TranslationSegment): void {
        translationSegment.translationState = TranslationState.Draft;
    }

    setStateTranslated(translationSegment: TranslationSegment): void {
        translationSegment.translationState = TranslationState.Translated;
    }

    setStatePreTranslated(translationSegment: TranslationSegment): void {
        translationSegment.translationState = TranslationState.PreTranslated;
    }

    setStateAutoTranslated(translationSegment: TranslationSegment): void {
        translationSegment.translationState = TranslationState.AutoTranslated;
    }

}